import React, { useContext, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import Divider from "@mui/material/Divider";

// ICONS
import HelpIcon from "@mui/icons-material/Help";
import ContactsIcon from "@mui/icons-material/Contacts";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";

import { UserContext } from "../context/userContext";
import { LanguageContext } from "../context/languageContext";
import { ListItemIcon } from "@mui/material";
import ConfirmDialog from "../utils/confirmDialog";
import Footer from "./footer";
import {
  loginPageLabels,
  appBarLabel,
  assessmentLabels,
  logoutLabel,
} from "../config/commonLabels";

const useStyles = makeStyles()((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  list: {
    width: 250,
  },
}));

export default function ClbsAppBar(props) {
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { tokenKey, userKey } = useContext(UserContext);
  const { language } = useContext(LanguageContext);
  const [token, setToken] = tokenKey;
  const [user, setUser] = userKey;
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({
    left: false,
  });

  const navigate = useNavigate();

  const toggleDrawer = (side, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [side]: open });
  };
  const sideList = (side) => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        {!user.isAdmin && (
          <ListItem>
            <ListItemButton onClick={() => navigate("/home")}>
              <ListItemIcon>
                <AssessmentIcon />
              </ListItemIcon>
              <ListItemText primary={appBarLabel.assessment[language]} />
            </ListItemButton>
          </ListItem>
        )}
        {user.isAdmin && (
          <ListItem>
            <ListItemButton onClick={() => navigate("/adminPanel")}>
              <ListItemIcon>
                <AdminPanelSettingsIcon />
              </ListItemIcon>
              <ListItemText primary={appBarLabel.adminPanel[language]} />
            </ListItemButton>
          </ListItem>
        )}
        {user.isAdmin && (
          <ListItem>
            <ListItemButton onClick={() => navigate("/accountManagement")}>
              <ListItemIcon>
                <ManageAccountsIcon />
              </ListItemIcon>
              <ListItemText primary={appBarLabel.accountManagement[language]} />
            </ListItemButton>
          </ListItem>
        )}
      </List>
      <Divider />
      <List>
        <ListItem>
          <ListItemButton onClick={() => navigate("/help")}>
            <ListItemIcon>
              <HelpIcon />
            </ListItemIcon>
            <ListItemText primary={assessmentLabels.help[language]} />
          </ListItemButton>
        </ListItem>
        <ListItem>
          <ListItemButton onClick={() => navigate("/contactUs")}>
            <ListItemIcon>
              <ContactsIcon />
            </ListItemIcon>
            <ListItemText primary={appBarLabel.contactUs[language]} />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  const handleLogout = () => {
    setToken(null);
    setUser({
      email: null,
      id: null,
      isAdmin: null,
    });
    localStorage.setItem("email", null);
    localStorage.setItem("id", null);
    localStorage.setItem("isAdmin", null);
    localStorage.setItem("currentPage", 1);
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer("left", true)}
          >
            <MenuIcon />
          </IconButton>
          <Box
            component="img"
            sx={{
              height: isMobile ? 35 : 50,
              width: isMobile ? 87.5 : 125,
              cursor: "pointer",
            }}
            alt="TalentLinkLogo"
            src="/Talentlink_white.png"
            onClick={() => navigate(user.isAdmin ? "/adminPanel" : "/home")}
          />
          <Box sx={{ flexGrow: 1 }} />
          {!token && (
            <Button
              startIcon={<LoginIcon fontSize={isMobile ? "small" : "medium"} />}
              color="inherit"
              size={isMobile ? "small" : "medium"}
              onClick={() => navigate("/login")}
              sx={isMobile ? { fontSize: "0.75rem" } : {}}
            >
              {loginPageLabels.login[language]}
            </Button>
          )}
          {token && (
            <Button
              startIcon={
                <LogoutIcon fontSize={isMobile ? "small" : "medium"} />
              }
              color="inherit"
              size={isMobile ? "small" : "medium"}
              onClick={() => setOpen(true)}
              sx={isMobile ? { fontSize: "0.75rem" } : {}}
            >
              {loginPageLabels.logout[language]}
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <ConfirmDialog
        open={open}
        onCloseDialog={() => setOpen(false)}
        title={logoutLabel.confirmLogout[language]}
        details={logoutLabel.confirmLogoutPrompt[language]}
        onConfirm={handleLogout}
      />
      <Drawer open={state.left} onClose={toggleDrawer("left", false)}>
        {sideList("left")}
      </Drawer>
      <Box sx={{ minHeight: "100vh" }}>{props.children}</Box>
      <Footer />
    </div>
  );
}
